import { lifeCycleEventName } from '../constant/lifeCycleEventName';
// 节流，下一个pipe将接收到一个数组
export const throttlePipe = (airTracker, maxLength) => {
    let timer;
    const retainedLogs = [];
    const { config } = airTracker;
    // as the first pipe, this will only recieve single log instead of array of logs
    return (log, resolve) => {
        retainedLogs.push(log);
        airTracker.lifeCycle.on(lifeCycleEventName.onCommonUpdated, () => {
            resolve === null || resolve === void 0 ? void 0 : resolve(retainedLogs.splice(0, retainedLogs.length));
            timer && clearTimeout(timer);
        });
        // if maxLength log exceed, it will flush all the logs
        if (maxLength && retainedLogs.length >= maxLength) {
            resolve === null || resolve === void 0 ? void 0 : resolve(retainedLogs.splice(0, retainedLogs.length));
            timer && clearTimeout(timer);
            return;
        }
        // otherwise, send logs in certain time interval
        timer && clearTimeout(timer);
        timer = setTimeout(() => {
            timer = null;
            if (retainedLogs.length > 0) {
                resolve === null || resolve === void 0 ? void 0 : resolve(retainedLogs.splice(0, retainedLogs.length));
            }
        }, config.delay);
    };
};
